import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import {BootstrapVue , BootstrapVueIcons} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import VeeValidate, { Validator }  from "vee-validate";
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'
import ToggleButton from 'vue-js-toggle-button'
import LoadScript from 'vue-plugin-load-script';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import pt_BR from "vee-validate/dist/locale/pt_BR";
import VueExcelXlsx from "vue-excel-xlsx";
import Vuelidate from 'vuelidate';
import VueHtmlToPaper from 'vue-html-to-paper';
import { updateLocale } from '@/node_modules/moment/moment'
import { url } from 'vuelidate/lib/validators'
import VCalendar from 'v-calendar';


 
Vue.use(LoadScript);
Vue.use(VCalendar, {
  componentPrefix: 'v',  // Use <vc-calendar /> instead of <v-calendar />
});
Vue.use(VueFeather)
Vue.use(flatPickr)

Vue.use(VueRouter)
Vue.use(vco)

Vue.use(ToggleButton)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VeeValidate);
Vue.use(Vuelidate)
Validator.localize("pt_BR", pt_BR);
Vue.use(VueMask)
// Options do HTMLTOPAPER
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/style/html-to-paper.css',
    '/style/termo-adesao.css',
    '/style/cartoes.css',
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}
Vue.use(VueHtmlToPaper, options);


Vue.use(VueExcelXlsx);
Vue.component('v-select', vSelect)
Vue.component('apexchart', VueApexCharts)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)


const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

